import React, {useState } from 'react'
import PageHeading from '../../../../components/common/PageHeading'
import RightBar from '../../../../components/common/RightBar'
import { Form, Input, Select, Button, Card, message, Steps, Row, Col, DatePicker } from "antd";
import StepHeading from './Components/StepHeading';
import RightBarMethod from '../../../../components/common/RightBar/RightBarMethod';
import MultiSelect from '../../../../components/common/MultiSelect';
import { states } from '../../../../utils/Util';
import Footer from '../../../../components/common/Footer';
import AgreementSignerItem from './Components/AgreementSignerItem';

const rightBarData = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
        RightBarMethod("Lease Templates", "1", "", "", "/leasing/leases/lease-templates"),
        RightBarMethod("PDF Form Templates", "2", "", "", "/leasing/leases/pdf-form-templates"),

    ]),
];

export const multiSelectOptions = [
    'owner 1',
    'owner 2',
    'owner 3',
    'owner 4',
];


function NewManagementAgreement() {

    const [owners, setOwners] = useState([]);

    const handleOwnersList = (e) => {
        setOwners(e);
    }

    const steps = [
        {
            title: 'Choose Owner(s) & Property',
            content: <ChooseOwnerProperty getOwnerList={handleOwnersList} ownersList={owners} />,
        },
        {
            title: 'Set Agreement Signer',
            content: <SetAgreementSigners owners={owners} />,
        },
        {
            title: 'Choose Template & Addenda',
            content: <ChooseTemplateAndAddenda />,
        }, {
            title: 'Choose Agreement Terms',
            content: <CompleteAgreementTerms address="Dummy Address"/>,
        },
    ];

    const [current, setCurrent] = useState(0);
    const next = () => {
        setCurrent(current + 1);
    };
    const prev = () => {
        setCurrent(current - 1);
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        marginTop: 16,
        paddingTop: 16,
        paddingBottom: 16,
    };

    console.log("current is " + current)

    const [policyWalkThrough, setPolicyWalkThrough] = useState(false)

    return (
        <>
            <div className="page-container">
                <div className="main-container">
                    <PageHeading heading="New Management Agreement" />

                    <Form
                        name="basic"
                        labelCol={{ span: 6 }}
                        initialValues={{ remember: true }}
                        autoComplete="off"
                        className="form-container"
                        colon={false}
                    >

                        <Steps className='managementSteps' current={current} items={items} labelPlacement="vertical" />
                        <div style={contentStyle}>{steps[current].content}</div>
                        <div
                            style={{
                                marginTop: 24,
                            }}
                        >

                            {current < steps.length - 1 && (
                                <Button type="primary" onClick={() => next()}>
                                    Continue
                                </Button>
                            )}


                            {current === steps.length - 1 && (
                                <Button type="primary" onClick={() => {
                                    setPolicyWalkThrough(false)
                                    message.success('complete')
                                }}>
                                    Generate Agreement
                                </Button>
                            )}
                            {current > 0 && (
                                <Button
                                    style={{
                                        margin: '0 8px',
                                    }}
                                    onClick={() => prev()}
                                >
                                    Back
                                </Button>

                            )}
                            <Button
                                style={{
                                    margin: '0 8px',
                                }}
                                onClick={() => setPolicyWalkThrough(false)}
                            >
                                Cancel
                            </Button>
                        </div>

                    </Form>
                    <Footer />

                </div>
            </div>

            <div className="RightSidebar">
                <RightBar RightBarData={rightBarData} />
            </div>

        </>
    )
}

export default NewManagementAgreement

function ChooseOwnerProperty(prop) {


    const handleSelectChange = (value) => {
        prop.getOwnerList(value);
    };

    return (
        <>

            <StepHeading heading="Step 1: Choose Owner(s) & Property" />

            <Card title="Owner Details" bordered={false}>

                <Form.Item
                    name='owners'
                    label="Owners"
                    rules={[{ required: true }]}
                >
                    <MultiSelect
                        options={multiSelectOptions}
                        placeholder="Select..."
                        className="filter-select"
                        callBackItems={handleSelectChange}
                    />

                </Form.Item>

            </Card>

            <br />

            <Card title="Ownership Percentage" bordered={false}>

                {prop.ownersList.length > 0 ? <>

                    <ul>
                        {prop.ownersList.map((item, index) => (
                            <li key={index}>
                                <Form.Item label={item}
                                    wrapperCol={{ span: 9 }}
                                >
                                    <Input suffix="%" disabled={prop.ownersList.length === 1 ? true : false} placeholder={prop.ownersList.length === 1 ? "100" : ""} />

                                </Form.Item>
                            </li>
                        ))}

                    </ul>

                </> :
                    <><p style={{ textAlign: "center" }}>You must select an owner first.</p></>}



            </Card>

            <br />

            <Card title="Property Details" bordered={false}>


                <Form.Item
                    label="Address"
                    name='address'
                    rules={[{ required: true }]}
                >
                    <Input placeholder="Address 1" />

                </Form.Item>

                <Form.Item label=" ">
                    <Input placeholder="Address 2" />
                </Form.Item>

                <Form.Item
                    label="City"
                >
                    <Row>
                        <Col flex={10}> <Input placeholder="City" /> </Col>
                        <Col flex={1}></Col>
                        <Col flex={2}><Select
                            options={states} />
                        </Col>
                        <Col flex={1}></Col>
                        <Col flex={2}><Input placeholder="Zip" /></Col>
                    </Row>
                </Form.Item>

                <Form.Item label="Country">
                    <Input placeholder="Counntry" />
                </Form.Item>

            </Card>



        </>
    )
}

function SetAgreementSigners(prop) {
    return (
        <>
            <StepHeading heading="Step 2: Set Agreement Signer" />


            <Card title="Agreement Signer" bordered={false}>

                <ul>

                    {console.log(prop.owners.length)}

                    {prop.owners.map((item, index) => (
                        <li key={index}>
                            <AgreementSignerItem title={item} />
                        </li>
                    ))}

                </ul>

            </Card>
        </>
    )
}

function ChooseTemplateAndAddenda() {
    return (
        <>
            <StepHeading heading="Step 3: Choose Template & Addenda" />

            <Card title="Choose Template" bordered={false}>

                <Form.Item
                    name="agreementTemp"
                    label="Agreement Template"
                    rules={[{ required: true }]}
                >
                    <Select placeholder='Select' />
                </Form.Item>

            </Card>

            <br />

            <Card title="Select Addenda" bordered={false}>

                <Form.Item
                    name="agreementAddenda"
                    label="Agreement Addenda"
                >
                    <Select placeholder='Click to add addenda' />

                </Form.Item>

            </Card>

            <br />

            <Card title="Select Attachmennts" bordered={false}>

                <Form.Item
                    name="attachments"
                    label="Attachments"
                >
                    <Select placeholder='Click to add attachments' />

                </Form.Item>

            </Card>

            <br />

        </>
    )
}


function CompleteAgreementTerms(prop) {
    return (
        <>
            <StepHeading heading="Step 4: Complete Agreement Terms" />

            <p style={{textAlign:"center", marginBottom:12}}><b>{prop.address}</b></p>

            <Card title="Managment Dates" bordered={false}>

                <Form.Item
                    name="startDate"
                    label="Management Start Date"
                    rules={[{ required: true }]}
                >
                    <DatePicker style={{width:'100%'}} />
                </Form.Item>

                <Form.Item
                    name="terminationDate"
                    label="Agreement Termination Date"
                >
                    <DatePicker style={{width:'100%'}} />
                </Form.Item>

            </Card>
        </>
    )
}